<template>
  <div class="input select-input">
    <text-input :placeholder="label" name="select" v-model="input"/>
    <div class="input-dropdown" v-if="opened">
      <div class="option" v-for="(option, index) in useOptions" @click="select(option)">
        <span>{{option[displayProp]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from './text-input';

export default {
  name: 'select-input',
  components: { TextInput },
  props: {
    label: String,
    options: Array,
    displayProp: String,
    valueProp: String,
  },
  watch: {
    input(o, v) {
      this.openDropdown();
    },
  },
  computed: {
    useOptions() {
      if (this.input === '') {
        return this.options;
      }
      return this.options.filter(o => o[this.displayProp].toLowerCase().indexOf(this.input.toLowerCase()) !== -1);
    },
  },
  methods: {
    select(item) {
      this.input = item[this.displayProp];
      this.$emit('input', item[this.valueProp]);
      this.$nextTick(() => {
        this.hideDropdown();
      });
    },
    openDropdown() {
      this.opened = true;
    },
    hideDropdown() {
      this.opened = false;
    },
  },
  data() {
    return {
      input: '',
      computedOptions: [],
      opened: false,
    };
  },
};
</script>

<style scoped>
  .input {
    position: relative;
  }
  .input-dropdown {
    position: absolute;
    background: #fff;
    -webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
    border-radius: 8px;
    width: 100%;
    z-index: 999;
    padding: 10px 0 10px 0;
    overflow-y: auto;
    max-height: 200px;
  }
  .input-dropdown .option {
    padding: 8px 14px 8px 14px;
    cursor: pointer;
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }
  .input-dropdown .option:hover {
    background: #c15842;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/select-input.vue